import { list } from '../../../../../../common/classes/request-builder';
import type {
    DropdownData,
} from '@fitogest/reactive-form-builder/interfaces';
import type { ClienteModel } from '../../../../../../models/cliente.model';
import type { FincasModel } from '../../../../../../models/form-common/fincas.module';
import type { ParcelasModel } from '../../../../../../models/form-common/parcelas.model';
import type { SectorModel } from '../../../../../../models/form-common/sector.model';
import type { MaquinariaModel } from '../../../../../../models/trabajadores/maquinaria.model';
import type { MantenimientoModel } from '../../../../../../models/trabajadores/mantenimiento.model';

const PRODUCTOS_ORDENADOS = [
    'Suelta de Enemigos Naturales',
    'Feromonas Picudo',
    'P. Persimilis (Spidex)',
    'A. Californicus (Spical)',
    'A. Swirkii (Swirski-mite)',
    'Cryptolaemus montrouzieri (Cryptoline)',
    'Crysoperla sp (Crysoline)',
    'Bioknock',
    'Equisetum arvense',
    'Tigre',
    'Micorriza (Aegis irriga)',
    'Btu-8 (Bactofus)',
    'Vigor Plus (Btu-8)',
    'Ácid plus (Btu-8)',
    'Nematodo Steirnernema carpocapsae (Biorend leñosos)',
    'Nematodo Heterorhabditis bacteriophora (Biorend melolontha)',
    'Nematodo Steirnernema feltiae ( Biorend invernaderos)',
    'Nematodo Steirnernema feltiae (Entonem)',
    'Kira',
    'Cynoil',
    'Extracto canela (Amicosec)',
    'Isr altech',
    'Jabón potásico (Neptasila)',
    'Bacillus thurigiensis israelensis (Vectobac)',
    'Bacillus thurigiensis israelensis granulado(Vectomax)',
    'Piretinas naturales 3% (Pirecris)',
    'Nematodo Heterorhabditis bacteriophora (Biorend trips)',
    'Nematodo Steirnernema carpocapsae (Capsanem)',
    'Trichoderma (Condor)',
    'Anagyrus pseudococci (Anagline)',
    'Isonet z',
    'Veni biosulfur (Azufre 70%)',
    'Cryptobug',
    'Citripar',
    'Aphytis',
    'Orius Laevigatus',
    'Orius Majusculus',
    'Beauveria Bassiana',
    'Rhizobug 250 adulto',
    'Amblyseius Andersoni',
    'Larvas Chrysoperla',
    'Phytoseiulus Persimilis',
    'Trichogramma Achaeae',
    'Pheromona Duponchelia Fovealis',
    'Euzophera Pinguis',
    'Opogona Sacchari',
    'Californicus System',
    'Feromona + Kairomona Rhynchonex (Picudo)',
    'Margaronia Unionalis',
    'Scyphophorus Acupunctatus',
    'Zeuzera Pyrina',
    'Hypoaspis System',
    'Phyllocnistis Citrella',
    'Pupas Anagyrus Vladimirii',
    'Anthocoris Nemoralis',
    'Amblyseius Swirskii',
    'Nesidiocoris Tenuis',
    'Stratiolaelaps Scimitus',
    'Econex Cromática Amarilla 20 X25 CM',
    'Econex Triangular Blanca Plegable (Trampa sin Lámina)',
    'Econex Lámina para Trampa Triangular',
    'Feromonas Prays Citri',
    'Feromonas Planococus Ficus',
    'Placas 20 X 25 CM Negras CAJA contiene 500 Uds.',
    'Aphidius colemani (fauna auxiliar)',
    'Mitsei',
    'Alliance',
    'Talos',
].sort();

export class TareasBioListsDefinition {
    public clientes: DropdownData<ClienteModel> = list<ClienteModel>();
    public fincas: DropdownData<FincasModel> = list<FincasModel>();
    public sectores: DropdownData<SectorModel> = list<SectorModel>();
    public parcelas: DropdownData<ParcelasModel> = list<ParcelasModel>();
    public trabajadores: DropdownData<MantenimientoModel> = list<MantenimientoModel>();
    public maquinarias: DropdownData<MaquinariaModel> = list<MaquinariaModel>();
    public productos: DropdownData<string> = list<string>(['...', null], ...PRODUCTOS_ORDENADOS);
    public tipoPlaga: DropdownData<string> = list<string>(
        ['...', null],
        'Ácaros',
        'Aguado',
        'Alternaria',
        'Amarre fruto',
        'Antracnosis',
        'Araña roja',
        'Ácaro blanco',
        'Caracoles',
        'Carencias',
        'Ceratitis',
        'Citripar',
        'Conservación',
        'Cotonet',
        'Cuajado',
        'Diaspinos',
        'Enfermedades tronco',
        'Engorde',
        'Estímulo',
        'Gusano blanco',
        'Gusano de alambre',
        'Gusano gris',
        'Heladas',
        'Hormigas',
        'Hongos',
        'Larvas Chrysoperla Carnea',
        'Malas hierbas',
        'Mejorante',
        'Melaza',
        'Minador',
        'Mosca blanca',
        'Mosca scatella',
        'Nutrición',
        'Oidio',
        'Orius Laevigatus',
        'Otiorrinco',
        'Piojo rojo de california',
        'Piojo blanco',
        'Phytophtora',
        'Phytoseiulus Persimilis',
        'Pulgones',
        'Sciara',
        'Trichoderma (Condor)',
        'Tipula',
        'Trips',
    );
    public estados: DropdownData<string> = list<string>('Planificado', 'Orden ficha', 'Aplicado');
    public estadoTarea: DropdownData<string> = list<string>(['...', null], 'Orden de Trabajo', 'Parte de Trabajo');
}
